import { fetcher } from 'redux/apisMember';
import { UserApply } from 'types';
import makeGetHook from '@eGroupTeam/hooks/makeGetHook';

export type PathParams = {
  activityId?: string;
  userApplyId?: string;
};
const useMemberUserApply = makeGetHook<UserApply, PathParams>(
  '/activities/{{activityId}}/user-applies/{{userApplyId}}',
  fetcher
);
export default useMemberUserApply;
